import {removeCurrent} from "@main/helpers";

export class Filter {
    constructor(el) {
        this.el = el;
        this.items = el.querySelectorAll(".js-filter-item");
        this.list = el.closest(".js-list");
        this.initEvents();
    }

    initEvents() {
        this.items.forEach((item) => {
            item.addEventListener("click", () => {
                if (!item.classList.contains("current")) {
                    removeCurrent(this.items);
                    item.classList.add("current");
                } else {
                    item.classList.remove("current");
                }
                this.list.dispatchEvent(new CustomEvent("loadList", {
                    detail: {resetNav: true}
                }));
            });
        });
    }
}

document.querySelectorAll(".js-filter").forEach(elem => new Filter(elem));
